module.exports = __webpack_public_path__ + "images/game/level-2.56984a07b7ed5ddd50be2c894fc88f32.png";